export default {"src":"/fly/_next/static/media/uy.6afaf1e3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};